import {fragments} from '@/gql';
const {gql} = require('graphql-tag');
export default gql`
  mutation createPerson($input: PersonInput!) {
    createPerson(input: $input) {
      ...personDetail
    }
  }
  ${fragments.personDetail}
`;
